module.exports = __webpack_public_path__ + "img/gpic1.png";